import { Component, EventEmitter, Output, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { Subscription } from 'rxjs';
import * as _ from 'lodash-es';
import { PartnerAllocNewService } from './partner-alloc-new.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
import { safeEvalFormula, isFiniteEvalNumber } from '../../../shared/_utils/safe-eval-formula';

@Component({
    selector: 'gtw-partner-alloc-new',
    templateUrl: './partner-alloc-new.component.html',
    styleUrls: ['./partner-alloc-new.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PartnerAllocNewComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly subs = new Subscription();

  baseURLs: any = {};
  filterParams: any = {};
  globalParams: any = {};
  USER_SETTINGS: any = {};
  SERVER_CONFIG: any = {};
  GENERAL_CONFIG: any = {};
  rowData: any = {};

  private isInitialized = false;
  private isLoading = false;

  // Standard component properties (V9 MANDATORY)
  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  showFormLoader = true;
  showSK3Loader = true;

  // Title
  modalTitle = '';
  allocationHeading = '';

  // User
  logged_in_user = '';

  // Tab state
  activeTab = 'TI';

  // K1 tab data
  allFormData: any[] = [];
  partHeaderIIFormData: any[] = [];
  k1caplibFormData: any[] = [];
  partHeaderIIIFormData: any[] = [];
  tiFormData: any[] = [];
  creditFormData: any[] = [];
  amtaceFormData: any[] = [];
  otherFormData: any[] = [];
  taxcapitalFormData: any[] = [];

  // K1 section toggles
  showK1Caplib = false;
  showTI = true;
  showCredits = false;
  showAMTACE = false;
  showOTHER = false;
  showTAXCAPITAL = false;

  // K1 dropdowns/formulas
  issueList: any[] = [];
  selectedIssue = '';
  allDropdownList: any[] = [];
  allFormFormulaList: any[] = [];

  // SK3 tab data
  all_1065SK3Data: any[] = [];
  all_1065SK3AttachmentData: any[] = [];
  allFormFormulaListSK3: any[] = [];
  form_key = '';
  schedule_name = '';

  // SK3 lookups
  countryCodeList: any[] = [];
  SIC_codes: any[] = [];
  countryList: any[] = [];
  taxTypes: any[] = [];
  currencyCodes: any[] = [];
  categoryCodes: any[] = [];
  defaultCountryCode: any;
  defaultCategory: any;

  // SK3 Page 1 data
  page1Header_1065SK3Data: any[] = [];
  page1_E_lines_1065SK3Data: any[] = [];
  firstRow: any = {};
  tax_year_begin = '';
  tax_year_end = '';
  pship_ein = '';
  pship_le_name = '';
  pship_address = '';
  pship_details = '';
  ptr_ein = '';
  ptr_le_name = '';
  ptr_address = '';
  ptr_details = '';
  E_line_Numbers: string[] = [];
  E_line_No_Desc_map = new Map<string, string>();
  finalK3Row: any = null;
  amendedK3Row: any = null;

  // SK3 Part headers and data
  partHeaders: Map<string, any[]> = new Map();
  part_I_1065SK3Data: any[] = [];

  // Part II transposed data
  category_code = '';
  category_key = '';
  part_II_s1_header_1065SK3Data: any[] = [];
  part_II_S1_1065SK3DataTransposed: any[] = [];
  part_II_s2_header_1065SK3Data: any[] = [];
  part_II_S2_1065SK3DataTransposed: any[] = [];
  part_II_s1_24h_n_s2_54_1065SK3DataTransposed: any[] = [];
  part_II_s2_55_1065SK3DataTransposed: any = null;
  partIIDescWidth = '50%';
  partIIHeaderDescWidth = '54%';
  partIIColWidth = '13%';

  // Part VIII
  part_VIII_header_1065SK3Data: any[] = [];
  part_VIII_1065SK3DataTransposed: any[] = [];
  part_VIII_1065SK3DataTransposed_deletePart: any[] = [];
  activePartVIIITab = 0;

  // SK3 part visibility
  showPartI = false;
  showPartII = false;
  showPartIII = false;
  showPartIV = false;
  showPartV = false;
  showPartVI = false;
  showPartVII = false;
  showPartVIII = false;
  showPartIX = false;
  showPartX = false;
  showPartXI = false;
  showPartXII = false;
  showPartXIII = false;

  // Row data fields
  TAX_YEAR = '';
  scenario = '';
  jcd_key = '';
  COMBINATION_KEY = '';
  PTR_COMBINATION_KEY = '';
  PSHIP_PTR_POSTING_KEY = '';
  PSHIP_INTERNAL_EXTERNAL_INDICATOR = '';
  PSHIP_HO_US_TAX_TYPE = '';
  form_type = '';
  attachment_parts = '';

  // Alpha array for K3
  alphaArray = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','aa','ab','ac','ad','ae','af','ag','ah','ai','aj','ak','al','am','an','ao','ap','aq','ar','as','at','au','av','aw','ax','ay','az'];

  // Generic part sections (III-XIII except II, VIII) - processed for rendering
  genericPartSections: Map<string, { sectionHeaders: any[], flatRows: any[], transposedData: any[], descWidth: string, headerDescWidth: string, colWidth: string }[]> = new Map();

  // Parts with hardcoded titles (not from data)
  hardcodedPartDescriptions: any = {
    'X': { prefix: '*', desc: 'Foreign Partner\'s Character and Source of Income and Deductions' },
    'XI': { prefix: '*', desc: 'Section 871(m) Covered Partnerships' },
    'XII': { prefix: '**', desc: 'Reserved for future use' },
    'XIII': { prefix: '*', desc: 'Foreign Partner\'s Distributive Share of Deemed Sale Items on Transfer of Partnership Interest' }
  };

  // Parts with attachment sections
  attachmentParts = ['I', 'VII', 'X', 'XI', 'XIII'];

  // Attachment file lists per part
  attachmentFiles: Map<string, string[]> = new Map();
  attachmentFileDetails: Map<string, any[]> = new Map();
  attachmentLoading: Map<string, boolean> = new Map();
  attachmentUploading: Map<string, boolean> = new Map();
  attachmentError: Map<string, string> = new Map();

  allowedExtensions = ['jpg','jpeg','png','svg','pdf','xls','xlsx','txt','doc','docx','ico','ppt','pptx','ods','wpd','rtf'];

  constructor(
    private service: PartnerAllocNewService,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.init();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};

    this.GENERAL_CONFIG = generalConfigFromGlobal(this.gtwGlobal);
    this.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
    this.USER_SETTINGS = this.gtwApp.USER_SETTINGS || {};
    this.SERVER_CONFIG = this.gtwApp.SERVER_CONFIG || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow) ? extractObject(rawRow[0]) : extractObject(rawRow);

    this.baseURLs = this.GENERAL_CONFIG;
    this.cdr.markForCheck();
  }

  private init() {
    if (this.isInitialized || this.isLoading) return;
    if (!this.GENERAL_CONFIG || !this.rowData || Object.keys(this.rowData).length === 0) return;
    if (!this.filterParams || Object.keys(this.filterParams).length === 0) return;
    this.isInitialized = true;
    try {
      this.logged_in_user = this.USER_SETTINGS?.user?.sso_id || '';

      this.setupRowDataFields();
      this.setupTitle();

      this.loadK1Data();
      this.loadSK3Data();
      this.loadLookups();
    } catch (e) {
      console.error('Error in init:', e);
      this.showFormLoader = false;
      this.showSK3Loader = false;
      this.cdr.detectChanges();
    }
  }

  private setupRowDataFields() {
    this.TAX_YEAR = this.filterParams.tax_year || this.rowData.TAX_YEAR || '';
    this.scenario = this.filterParams.scenario || this.rowData.SCENARIO || '';
    this.jcd_key = this.globalParams?.jcd_key || this.filterParams.jcd_key || '';
    this.COMBINATION_KEY = this.rowData.COMBINATION_KEY || '';
    this.PTR_COMBINATION_KEY = this.rowData.PTR_COMBINATION_KEY || '';
    this.PSHIP_PTR_POSTING_KEY = this.rowData.PSHIP_PTR_POSTING_KEY || '';
    this.PSHIP_INTERNAL_EXTERNAL_INDICATOR = this.rowData.PSHIP_INTERNAL_EXTERNAL_INDICATOR || '';
    this.PSHIP_HO_US_TAX_TYPE = this.rowData.PSHIP_HO_US_TAX_TYPE || '';
    this.attachment_parts = this.rowData.ATTACHMENT_PARTS || '';

    if (this.PSHIP_HO_US_TAX_TYPE === 'PTSP' || this.PSHIP_HO_US_TAX_TYPE === 'NCPTSP' || this.PSHIP_HO_US_TAX_TYPE === 'NCPTSPNF') {
      this.form_type = '8865';
    } else {
      this.form_type = '1065';
    }

    if (this.PSHIP_INTERNAL_EXTERNAL_INDICATOR === 'INTERNAL') {
      this.allocationHeading = 'Partner Allocation - Schedule K';
    } else if (this.PSHIP_INTERNAL_EXTERNAL_INDICATOR === 'EXTERNAL') {
      this.allocationHeading = 'Partner Allocation - External K1';
    }
  }

  private setupTitle() {
    this.modalTitle = 'Partnership Details: ' + (this.rowData.PSHIP_LEID || '') + ' / ' +
      (this.rowData.PSHIP_REPORTING_PERIOD || '') + ' - Partner Details: ' +
      (this.rowData.POSTING_PARTNER_LEID || '') + ' / ' + (this.rowData.POSTING_PARTNER_REPORTING_PERIOD || '');
  }

  // ─── K1 TAB DATA LOADING ─────────────────────────────────────────────

  private loadK1Data() {
    this.showFormLoader = true;
    this.isLoading = true;

    this.service.loadK1FormDetails(
      this.GENERAL_CONFIG.base_url, this.rowData, this.logged_in_user
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.processK1FormData(response.jsonObject);
        this.loadIssueDetails();
        this.loadIssueDropdown();
        this.loadFormFormulas();
        this.showFormLoader = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading K1 form details:', error);
        this.showFormLoader = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  private processK1FormData(data: any[]) {
    this.allFormData = data;
    this.partHeaderIIFormData = _.filter(data, { ATTRIB_NAME: 'EXTK1_K1_II_PART_HEADER' });
    this.k1caplibFormData = _.filter(data, { SECTION_NAME: 'K1CAPLIB' });
    this.partHeaderIIIFormData = _.filter(data, { ATTRIB_NAME: 'EXTK1_K1_III_PART_HEADER' });
    this.tiFormData = _.filter(data, { SECTION_NAME: 'TI' });
    this.creditFormData = _.filter(data, { SECTION_NAME: 'CREDIT' });
    this.amtaceFormData = _.filter(data, { SECTION_NAME: 'AMTACE' });

    const otherRaw = _.filter(data, { SECTION_NAME: 'OTHER' });
    this.otherFormData = otherRaw.map((obj: any) => {
      if (this.isJson(obj.ATTRIB_VALUE) && obj.SUB_FORM != null) {
        obj.ATTRIB_VALUE = safeJsonInput<any>(obj.ATTRIB_VALUE, null, 'partner-alloc-new.parse1');
      }
      return obj;
    });

    this.taxcapitalFormData = _.filter(data, { SECTION_NAME: 'TAXCAPITAL' });
  }

  private loadIssueDetails() {
    this.service.loadIssueDetails(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.jcd_key,
      this.COMBINATION_KEY, this.PTR_COMBINATION_KEY
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.jsonObject?.length > 0) {
          this.selectedIssue = response.jsonObject[0].ISSUE_ID_SHORT_DESC || '';
        }
        this.cdr.detectChanges();
      }
    );
  }

  private loadIssueDropdown() {
    this.service.loadIssueDropdown(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.jcd_key
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.issueList = response.jsonObject || [];
        this.loadAllDropdowns();
        this.cdr.detectChanges();
      }
    );
  }

  private loadAllDropdowns() {
    this.service.loadAllDropdowns(this.GENERAL_CONFIG.base_url, this.TAX_YEAR).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.allDropdownList = response.jsonObject || [];
        this.cdr.detectChanges();
      }
    );
  }

  private loadFormFormulas() {
    this.service.loadFormFormulaDetails(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, '', ''
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.allFormFormulaList = response.jsonObject || [];
        this.cdr.detectChanges();
      }
    );
  }

  // ─── SK3 TAB DATA LOADING ────────────────────────────────────────────

  private loadSK3Data() {
    this.showSK3Loader = true;

    this.service.loadSK3FormulaDetails(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.jcd_key, '', ''
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.allFormFormulaListSK3 = response.jsonObject || [];
        this.cdr.detectChanges();
      }
    );

    this.service.loadSK3Details(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.jcd_key,
      this.COMBINATION_KEY, this.PTR_COMBINATION_KEY
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.jsonObject?.length) {
          this.all_1065SK3Data = response.jsonObject;
          this.form_key = this.all_1065SK3Data[0].FORM_KEY || '';
          this.schedule_name = this.all_1065SK3Data[0].SCHEDULE_NAME || '';

          this.loadSK3Attachments();
        } else {
          this.showSK3Loader = false;
          this.gtwSnackbar.openSnackBar('No data found for Schedule K-3', 'gtw-snackbar--red', true, 4);
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        this.showSK3Loader = false;
        this.cdr.detectChanges();
      }
    );
  }

  private loadSK3Attachments() {
    this.service.loadSK3AttachmentDetails(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.jcd_key,
      this.COMBINATION_KEY, this.PTR_COMBINATION_KEY,
      this.form_key, this.schedule_name, this.logged_in_user
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.all_1065SK3AttachmentData = response.jsonObject || [];
        this.loadAttachmentFilesForParts();
        this.loadDefaultCountryAndRender();
      },
      (error: any) => {
        this.showSK3Loader = false;
        this.cdr.detectChanges();
      }
    );
  }

  private loadAttachmentFilesForParts() {
    const partOrderMap: any = { 'I': 1, 'VII': 7, 'X': 10, 'XI': 11, 'XIII': 13 };
    const adminUrl = this.GENERAL_CONFIG.admin_api_url;

    for (const partNo of this.attachmentParts) {
      const partOrder = partOrderMap[partNo];
      const metadata = _.filter(this.all_1065SK3AttachmentData, (r: any) =>
        String(r.PART_NO) === partNo && String(r.PART_ORDER) == String(partOrder)
      );
      const fileKeys = metadata.map((m: any) => m.FILE_KEY).filter((k: any) => k != null && k !== '' && k !== 0);

      if (fileKeys.length === 0) {
        this.attachmentFiles.set(partNo, []);
        this.attachmentFileDetails.set(partNo, []);
        continue;
      }

      this.attachmentLoading.set(partNo, true);
      const fileKeySetString = fileKeys.join(',');

      this.service.loadAttachmentsByFileKeySet(adminUrl, fileKeySetString).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (response: any) => {
          const files: string[] = [];
          const savedList = response.p_cursor || [];
          for (const attachment of savedList) {
            attachment.fS = this.formatBytes(attachment.file_size);
            files.push(attachment.file_name + '.' + attachment.file_type);
          }
          this.attachmentFiles.set(partNo, _.uniq(files));
          this.attachmentFileDetails.set(partNo, savedList);
          this.attachmentLoading.set(partNo, false);
          this.cdr.detectChanges();
        },
        () => {
          this.attachmentFiles.set(partNo, []);
          this.attachmentFileDetails.set(partNo, []);
          this.attachmentLoading.set(partNo, false);
          this.cdr.detectChanges();
        }
      );
    }
  }

  private loadDefaultCountryAndRender() {
    this.service.getDefaultCountryCode(this.GENERAL_CONFIG.base_url, this.TAX_YEAR).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.defaultCountryCode = response.jsonObject?.[0]?.CODE_SHORT_DESC || null;
        this.renderAllSK3Parts();
        this.loadDefaultCategory();
        this.showSK3Loader = false;
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.renderAllSK3Parts();
        this.showSK3Loader = false;
        this.cdr.detectChanges();
      }
    );
  }

  private renderAllSK3Parts() {
    if (!this.all_1065SK3Data.length) return;

    this.renderPage1();
    this.renderPartHeaders();
    this.part_I_1065SK3Data = _.filter(this.all_1065SK3Data, (r: any) =>
      r.PART_NO === 'I' && r.SECTION_NAME === 'N/A' &&
      r.ATTRIB_NAME && String(r.ATTRIB_NAME).indexOf('1065_K3_I_N/A') !== -1
    );
    this.renderPartII();
    this.renderPartVIII();
    this.renderGenericParts();
  }

  private renderPage1() {
    this.page1Header_1065SK3Data = _.filter(this.all_1065SK3Data, { ATTRIB_NAME: '1065_K3_N/A_N/A_N/A' });

    const firstRowArr = _.filter(this.all_1065SK3Data, { ATTRIB_NAME: '1065_K3_N/A_N/A_N/A_F' });
    if (firstRowArr.length > 0) {
      this.firstRow = firstRowArr[0];
      this.tax_year_begin = this.firstRow.OWNERSHIP_BEGIN_DATE || '';
      this.tax_year_end = this.firstRow.OWNERSHIP_END_DATE || '';
      this.pship_ein = this.firstRow.PSHIP_EIN || '';
      this.pship_le_name = this.firstRow.PSHIP_LE_NAME || '';
      this.pship_address = this.firstRow.PSHIP_ADDRESS || '';
      this.pship_details = this.pship_le_name + ' , ' + this.pship_address;
      this.ptr_ein = this.firstRow.PTR_EIN || '';
      this.ptr_le_name = this.firstRow.PTR_LE_NAME || '';
      this.ptr_address = this.firstRow.PTR_ADDRESS || '';
      this.ptr_details = this.ptr_le_name + ' , ' + this.ptr_address;
    }

    const allFinalK3 = _.filter(this.all_1065SK3Data, (item: any) =>
      item.DISPLAY === 'Y' && item.IS_FORM_DISPLAY === 'Y' &&
      item.PART_NO === 'N/A' && item.SECTION_NAME === 'N/A' &&
      item.LINE_NO === 'N/A' && item.ROW_TYPE === 'PL' && item.LINE_DESCRIPTION === 'Final K-3'
    );
    this.finalK3Row = allFinalK3.length > 0 ? allFinalK3[0] : null;

    const allAmendedK3 = _.filter(this.all_1065SK3Data, (item: any) =>
      item.DISPLAY === 'Y' && item.IS_FORM_DISPLAY === 'Y' &&
      item.PART_NO === 'N/A' && item.SECTION_NAME === 'N/A' &&
      item.LINE_NO === 'N/A' && item.ROW_TYPE === 'PL' && item.LINE_DESCRIPTION === 'Amended K-3'
    );
    this.amendedK3Row = allAmendedK3.length > 0 ? allAmendedK3[0] : null;

    this.page1_E_lines_1065SK3Data = _.filter(this.all_1065SK3Data, (item: any) =>
      item.ATTRIB_NAME && item.ATTRIB_NAME.indexOf('1065_K3_N/A_N/A_E') !== -1
    );

    if (this.all_1065SK3Data[0]?.FORM_TYPE === '8865') {
      this.page1_E_lines_1065SK3Data = this.page1_E_lines_1065SK3Data.slice(0, this.page1_E_lines_1065SK3Data.length - 5);
    }

    this.E_line_Numbers = [];
    this.E_line_No_Desc_map = new Map();
    for (const rec of this.page1_E_lines_1065SK3Data) {
      const lineNo = rec.LINE_NO;
      const lineDesc = rec.LINE_DESCRIPTION;
      if (!this.E_line_Numbers.includes(lineNo)) {
        this.E_line_Numbers.push(lineNo);
        this.E_line_No_Desc_map.set(lineNo, lineDesc);
      }
    }
  }

  private renderPartHeaders() {
    const partNos = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII'];
    for (const partNo of partNos) {
      const headers = _.filter(this.all_1065SK3Data, { PART_NO: partNo, ROW_TYPE: 'PH' });
      this.partHeaders.set(partNo, headers);
    }
  }

  getPartHeaderDescription(partNo: string): string {
    if (this.hardcodedPartDescriptions[partNo]) {
      return this.hardcodedPartDescriptions[partNo].desc;
    }
    const headers = this.partHeaders.get(partNo);
    return headers && headers.length > 0 ? headers[0].LINE_DESCRIPTION : '';
  }

  getPartPrefix(partNo: string): string {
    if (this.hardcodedPartDescriptions[partNo]) {
      return this.hardcodedPartDescriptions[partNo].prefix;
    }
    if (partNo === 'VII') return '*';
    return '';
  }

  hasAttachmentSection(partNo: string): boolean {
    return this.attachmentParts.includes(partNo);
  }

  isReservedPart(partNo: string): boolean {
    return partNo === 'VIII' || partNo === 'XII';
  }

  getAttachmentFiles(partNo: string): string[] {
    return this.attachmentFiles.get(partNo) || [];
  }

  isAttachmentLoading(partNo: string): boolean {
    return this.attachmentLoading.get(partNo) || false;
  }

  isAttachmentUploading(partNo: string): boolean {
    return this.attachmentUploading.get(partNo) || false;
  }

  getAttachmentError(partNo: string): string {
    return this.attachmentError.get(partNo) || '';
  }

  private getUploadQueryParams(partNo: string): any {
    return {
      tax_year: this.TAX_YEAR,
      scenario: this.scenario,
      jcd_key: this.jcd_key,
      sso_id: this.logged_in_user,
      combination_key: this.COMBINATION_KEY,
      ptr_combination_key: this.PTR_COMBINATION_KEY,
      form_key: this.form_key,
      schedule_name: this.schedule_name,
      partNo: partNo,
      section_name: 'NA'
    };
  }

  onAttachmentFileSelected(partNo: string, event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    input.value = '';

    const sanitizedName = file.name.replace(/[^-a-zA-Z0-9\s.]/gi, '_');
    const dotCount = (sanitizedName.match(/\./g) || []).length;

    if (dotCount === 0) {
      this.attachmentError.set(partNo, 'Unsupported file (no extension)');
      this.clearAttachmentError(partNo);
      this.cdr.detectChanges();
      return;
    }

    if (dotCount > 1) {
      this.attachmentError.set(partNo, sanitizedName + ' is invalid, has multiple periods.');
      this.clearAttachmentError(partNo);
      this.cdr.detectChanges();
      return;
    }

    const ext = sanitizedName.split('.').pop()?.toLowerCase() || '';
    if (!this.allowedExtensions.includes(ext)) {
      this.attachmentError.set(partNo, sanitizedName + ' is invalid. Allowed: ' + this.allowedExtensions.join(', '));
      this.clearAttachmentError(partNo);
      this.cdr.detectChanges();
      return;
    }

    const maxSize = this.SERVER_CONFIG?.configSettings?.fileUploadMaxSize;
    if (maxSize && file.size > maxSize) {
      this.attachmentError.set(partNo, sanitizedName + ' exceeds the allowed maximum size.');
      this.clearAttachmentError(partNo);
      this.cdr.detectChanges();
      return;
    }

    const existingFiles = this.attachmentFiles.get(partNo) || [];
    if (existingFiles.includes(sanitizedName)) {
      this.attachmentError.set(partNo, 'Same file name exists. Delete the existing document and re-upload or rename the file.');
      this.clearAttachmentError(partNo);
      this.cdr.detectChanges();
      return;
    }

    const renamedFile = new File([file], sanitizedName, { type: file.type });
    this.uploadAttachmentFile(partNo, renamedFile);
  }

  private clearAttachmentError(partNo: string) {
    setTimeout(() => {
      this.attachmentError.set(partNo, '');
      this.cdr.detectChanges();
    }, 6000);
  }

  private uploadAttachmentFile(partNo: string, file: File) {
    this.attachmentError.set(partNo, '');
    this.attachmentUploading.set(partNo, true);
    this.cdr.detectChanges();

    const adminUrl = this.GENERAL_CONFIG.admin_api_url;
    const queryParams = this.getUploadQueryParams(partNo);

    this.service.uploadK3Attachment(adminUrl, file, queryParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        console.log('[ATTACHMENT] upload response:', response);
        this.attachmentUploading.set(partNo, false);
        if (response?.callSuccess === '0') {
          this.attachmentError.set(partNo, response.errorMessage || 'Upload failed');
          this.clearAttachmentError(partNo);
          this.cdr.detectChanges();
        } else {
          const existingFiles = this.attachmentFiles.get(partNo) || [];
          if (!existingFiles.includes(file.name)) {
            existingFiles.push(file.name);
            this.attachmentFiles.set(partNo, _.uniq(existingFiles));
          }
          this.cdr.detectChanges();
          this.refreshAttachmentsForPart(partNo);
        }
      },
      (error: any) => {
        console.error('[ATTACHMENT] upload error:', error);
        this.attachmentUploading.set(partNo, false);
        this.attachmentError.set(partNo, 'Error uploading file');
        this.clearAttachmentError(partNo);
        this.cdr.detectChanges();
      }
    );
  }

  private refreshAttachmentsForPart(partNo: string) {
    console.log('[ATTACHMENT] refreshAttachmentsForPart called for', partNo);
    this.service.loadSK3AttachmentDetails(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.jcd_key,
      this.COMBINATION_KEY, this.PTR_COMBINATION_KEY,
      this.form_key, this.schedule_name, this.logged_in_user
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.all_1065SK3AttachmentData = response.jsonObject || [];
        console.log('[ATTACHMENT] attachmentData refreshed, count:', this.all_1065SK3AttachmentData.length);
        this.reloadFilesForPart(partNo);
      },
      (error: any) => {
        console.error('[ATTACHMENT] loadSK3AttachmentDetails error:', error);
        this.attachmentUploading.set(partNo, false);
        this.cdr.detectChanges();
      }
    );
  }

  private reloadFilesForPart(partNo: string) {
    const partOrderMap: any = { 'I': 1, 'VII': 7, 'X': 10, 'XI': 11, 'XIII': 13 };
    const adminUrl = this.GENERAL_CONFIG.admin_api_url;
    const partOrder = partOrderMap[partNo];
    const metadata = _.filter(this.all_1065SK3AttachmentData, (r: any) =>
      String(r.PART_NO) === partNo && String(r.PART_ORDER) == String(partOrder)
    );
    const fileKeys = metadata.map((m: any) => m.FILE_KEY).filter((k: any) => k != null && k !== '' && k !== 0);

    console.log('[ATTACHMENT] reloadFilesForPart', partNo, 'metadata:', metadata.length, 'fileKeys:', fileKeys);

    if (fileKeys.length === 0) {
      this.attachmentUploading.set(partNo, false);
      this.cdr.detectChanges();
      return;
    }

    this.service.loadAttachmentsByFileKeySet(adminUrl, fileKeys.join(',')).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        console.log('[ATTACHMENT] loadAttachmentsByFileKeySet raw response:', JSON.stringify(response));
        const savedList = response.p_cursor || response.jsonObject || [];
        const serverFiles: string[] = [];
        for (const att of savedList) {
          att.fS = this.formatBytes(att.file_size);
          serverFiles.push(att.file_name + '.' + att.file_type);
        }
        const localFiles = this.attachmentFiles.get(partNo) || [];
        const merged = _.uniq([...serverFiles, ...localFiles]);
        this.attachmentFiles.set(partNo, merged);
        if (savedList.length > 0) {
          this.attachmentFileDetails.set(partNo, savedList);
        }
        this.attachmentUploading.set(partNo, false);
        this.cdr.detectChanges();
        console.log('[ATTACHMENT] files loaded for', partNo, ':', merged);
      },
      (error: any) => {
        console.error('[ATTACHMENT] loadAttachmentsByFileKeySet error:', error);
        this.attachmentUploading.set(partNo, false);
        this.cdr.detectChanges();
      }
    );
  }

  downloadAttachment(partNo: string, fileName: string) {
    const details = this.attachmentFileDetails.get(partNo) || [];
    const parts = fileName.split('.');
    const name = parts.slice(0, -1).join('.');
    const type = parts[parts.length - 1];
    const fileObj = _.find(details, { file_name: name, file_type: type });
    if (!fileObj) return;

    const adminUrl = this.GENERAL_CONFIG.admin_api_url;
    const clientKey = sessionStorage.getItem('client_key') || '';

    this.service.getAPIAuthToken(this.GENERAL_CONFIG.base_url).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((tokenResp: any) => {
      const apiToken = encodeURIComponent(tokenResp.apiToken);
      const downloadUrl = `${adminUrl}/downloadPshipAttachment?fileName=${fileName}&fileKey=${fileObj.file_key}&client_key=${clientKey}&apiToken=${apiToken}&georaclehrid=${this.logged_in_user}`;
      window.open(downloadUrl, '_blank');
    });
  }

  removeAttachment(partNo: string, fileName: string) {
    if (!confirm('Are you sure you want to remove this attachment?')) return;

    const details = this.attachmentFileDetails.get(partNo) || [];
    const parts = fileName.split('.');
    const name = parts.slice(0, -1).join('.');
    const type = parts[parts.length - 1];
    const fileObj = _.find(details, { file_name: name, file_type: type });
    if (!fileObj) return;

    const adminUrl = this.GENERAL_CONFIG.admin_api_url;
    this.service.deleteStoredAttachment(adminUrl, fileName, fileObj.file_key).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.p_retval === '1' && response.p_error_out == null) {
          this.refreshAttachmentsForPart(partNo);
        } else if (response.p_retval === '0' && response.p_error_out != null) {
          this.gtwSnackbar.openSnackBar(response.p_error_out, 'gtw-snackbar--red', true, 4);
        } else if (response.callSuccess === '0' && response.errorMessage != null) {
          this.gtwSnackbar.openSnackBar(response.errorMessage, 'gtw-snackbar--red', true, 4);
        }
      },
      () => {
        this.gtwSnackbar.openSnackBar('Problem removing attachment.', 'gtw-snackbar--red', true, 4);
      }
    );
  }

  getPage1HeaderByOrder(lineOrder: number): any {
    return _.find(this.page1Header_1065SK3Data, (item: any) =>
      item.DISPLAY === 'Y' && item.IS_FORM_DISPLAY === 'Y' && item.LINE_ORDER === lineOrder
    );
  }

  getPage1FieldA(): any {
    return _.find(this.all_1065SK3Data, (item: any) =>
      item.DISPLAY === 'Y' && item.IS_FORM_DISPLAY === 'Y' && item.ROW_TYPE === 'LH' && item.ATTRIB_NAME === '1065_K3_N/A_N/A_A'
    );
  }

  getPage1FieldB(): any {
    return _.find(this.all_1065SK3Data, (item: any) =>
      item.DISPLAY === 'Y' && item.IS_FORM_DISPLAY === 'Y' && item.ROW_TYPE === 'LH' && item.ATTRIB_NAME === '1065_K3_N/A_N/A_B'
    );
  }

  getPage1FieldC(): any {
    return _.find(this.all_1065SK3Data, (item: any) =>
      item.DISPLAY === 'Y' && item.IS_FORM_DISPLAY === 'Y' && item.ROW_TYPE === 'LH' && item.ATTRIB_NAME === '1065_K3_N/A_N/A_C'
    );
  }

  getPage1FieldD(): any {
    return _.find(this.all_1065SK3Data, (item: any) =>
      item.DISPLAY === 'Y' && item.IS_FORM_DISPLAY === 'Y' && item.ROW_TYPE === 'LH' && item.ATTRIB_NAME === '1065_K3_N/A_N/A_D'
    );
  }

  getELineRecords(lineNo: string): any[] {
    return _.filter(this.page1_E_lines_1065SK3Data, { LINE_NO: lineNo });
  }

  getTaxYearBeginParts(): string[] {
    return this.tax_year_begin ? this.tax_year_begin.split('/') : ['', ''];
  }

  getTaxYearEndParts(): string[] {
    return this.tax_year_end ? this.tax_year_end.split('/') : ['', '', ''];
  }

  private loadDefaultCategory() {
    this.service.getDefaultCategory(this.GENERAL_CONFIG.base_url, this.TAX_YEAR).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.defaultCategory = response.jsonObject?.[0] || null;
        if (this.defaultCategory) {
          this.category_key = this.defaultCategory.CODE_KEY || '';
          this.category_code = this.defaultCategory.CODE_SHORT_DESC || '';
        }
        this.cdr.detectChanges();
        this.loadCountryAndLookups();
      }
    );
  }

  // ─── LOOKUPS ──────────────────────────────────────────────────────────

  private loadLookups() {
    // Non-blocking lookup loads
  }

  private loadCountryAndLookups() {
    this.service.loadCountryCodeList(this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.logged_in_user).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.countryCodeList = response.jsonObject || [];
        this.cdr.detectChanges();
      }
    );
    this.service.loadSICCodes(this.GENERAL_CONFIG.base_url, this.TAX_YEAR).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.SIC_codes = response.jsonObject || [];
        this.cdr.detectChanges();
      }
    );
    this.service.getCountryList(this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.logged_in_user).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.countryList = response.jsonObject || [];
        this.cdr.detectChanges();
      }
    );
    this.service.getTaxTypes(this.GENERAL_CONFIG.base_url, this.TAX_YEAR).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.taxTypes = response.jsonObject || [];
        this.cdr.detectChanges();
      }
    );
    this.service.getCurrencyCodes(this.GENERAL_CONFIG.base_url, this.TAX_YEAR).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.currencyCodes = response.jsonObject || [];
        this.cdr.detectChanges();
      }
    );
    this.service.getCategoryCodes(this.GENERAL_CONFIG.base_url, this.TAX_YEAR).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.categoryCodes = response.jsonObject || [];
        this.cdr.detectChanges();
      }
    );
  }

  // ─── K1 TAB LOGIC ────────────────────────────────────────────────────

  displayDropDownList(formLineKey: string, codeGroup: string): any[] {
    const listOfSelectedGroup = _.filter(this.allDropdownList, { CODE_GROUP: codeGroup });
    return listOfSelectedGroup.map((item: any) => ({
      name: item.CODE_DESC,
      value: item.CODE_KEY
    }));
  }

  showHideSection(id: string) {
    if (id === 'k1caplib') this.showK1Caplib = !this.showK1Caplib;
    if (id === 'ti') this.showTI = !this.showTI;
    if (id === 'credits') this.showCredits = !this.showCredits;
    if (id === 'amtace') this.showAMTACE = !this.showAMTACE;
    if (id === 'other') this.showOTHER = !this.showOTHER;
    if (id === 'taxcapital') this.showTAXCAPITAL = !this.showTAXCAPITAL;
    this.cdr.detectChanges();
  }

  setChange(row: any) {
    if (row.ROW_TYPE === 'PL') {
      row.IS_CHANGED_FLAG = 'Y';
      row.ROW_OCCURRENCE = 1;
      row.COL_OCCURRENCE = 1;
    } else if (row.ROW_TYPE === 'DT') {
      row.IS_CHANGED_FLAG = 'Y';
      row.ROW_OCCURRENCE = 1;
      row.COL_OCCURRENCE = 1;
    }
  }

  applyFormulaMain(row: any) {
    row.IS_CHANGED_FLAG = 'Y';
    if (row.DATA_TYPE === 'number') {
      const sectionName = row.SECTION_NAME;
      if (['K1CAPLIB', 'TI', 'CREDIT', 'AMTACE', 'OTHER', 'TAXCAPITAL'].includes(sectionName)) {
        const formFormulaList = this.filterFormulasBySubstring(this.allFormFormulaList, sectionName, sectionName);
        const formList = _.filter(this.allFormData, { SECTION_NAME: sectionName });
        for (const formula of formFormulaList) {
          if (formula.ATTRIB_CALC_FORMULA?.trim().length > 0) {
            this.calcAmt(formula.ATTRIB_CALC_FORMULA, formula.LINE_NO, formula.LINE_ATTRIB_KEY, row.DATA_TYPE, formList);
          }
        }
      }

      // Dependent TAXCAPITAL calculations
      const formListTaxCap = _.filter(this.allFormData, { SECTION_NAME: 'TAXCAPITAL' });
      const formulaListTaxCap = _.filter(this.allFormFormulaList, { SECTION_NAME: 'TAXCAPITAL' });

      const dependentFormulas = [
        ..._.filter(formulaListTaxCap, (f: any) => f.ATTRIB_CALC_FORMULA && String(f.ATTRIB_CALC_FORMULA).indexOf('K1CAPLIB') !== -1),
        ..._.filter(formulaListTaxCap, (f: any) => f.ATTRIB_CALC_FORMULA && String(f.ATTRIB_CALC_FORMULA).indexOf('TI') !== -1),
        ..._.filter(formulaListTaxCap, (f: any) => f.ATTRIB_CALC_FORMULA && String(f.ATTRIB_CALC_FORMULA).indexOf('OTHER') !== -1)
      ];

      for (const formula of dependentFormulas) {
        if (formula.ATTRIB_CALC_FORMULA?.trim().length > 0) {
          this.calcTaxCapitalAmt(formula.ATTRIB_CALC_FORMULA, formula.LINE_NO, formula.LINE_ATTRIB_KEY, row.DATA_TYPE, formListTaxCap);
        }
      }

      const taxCapFormulas = this.filterFormulasBySubstring(this.allFormFormulaList, 'TAXCAPITAL', 'TAXCAPITAL');
      const taxCapFormList = _.filter(this.allFormData, { SECTION_NAME: 'TAXCAPITAL' });
      for (const formula of taxCapFormulas) {
        if (formula.ATTRIB_CALC_FORMULA?.trim().length > 0) {
          this.calcAmt(formula.ATTRIB_CALC_FORMULA, formula.LINE_NO, formula.LINE_ATTRIB_KEY, row.DATA_TYPE, taxCapFormList);
        }
      }
    }
    this.cdr.detectChanges();
  }

  private filterFormulasBySubstring(formulaList: any[], sectionName: string, formulaSubstring: string): any[] {
    return _.filter(formulaList, (f: any) =>
      f.SECTION_NAME === sectionName &&
      f.ATTRIB_CALC_FORMULA &&
      String(f.ATTRIB_CALC_FORMULA).indexOf(formulaSubstring) !== -1
    );
  }

  private calcAmt(formula: string, lineNo: string, attribKey: string, dataType: string, targetFormList: any[]) {
    try {
      const matches = formula.match(/\b[^\d\s]+\b/g);
      let lineFormulaArray: string[] = [];
      if (matches == null) {
        lineFormulaArray = formula.split(/[+-/\\*\\]/);
      }

      for (let i = 0; i < lineFormulaArray.length; i++) {
        lineFormulaArray[i] = lineFormulaArray[i].replace(/"/g, '').replace(/'/g, '').replace(/\(|\)/g, '');
        const formulaOperandText = lineFormulaArray[i].trim();
        const sourceItem = _.find(targetFormList, { ATTRIB_NAME: formulaOperandText, DATA_TYPE: 'number' });
        if (!sourceItem) continue;
        const lineAmt = parseFloat(sourceItem.ATTRIB_VALUE) || 0;
        if (lineAmt >= 0) {
          formula = formula.replace('(' + lineFormulaArray[i].trim() + ')', String(lineAmt));
        } else {
          formula = formula.replace('(' + lineFormulaArray[i].trim() + ')', '(' + lineAmt + ')');
        }
      }

      const evalResult = safeEvalFormula(formula, null, 'partner-alloc-new');
      if (evalResult != null && typeof evalResult !== 'undefined' && isFiniteEvalNumber(evalResult)) {
        const targetItem = _.filter(targetFormList, { LINE_NO: lineNo, LINE_ATTRIB_KEY: attribKey });
        if (targetItem.length > 0) {
          const originalValue = targetItem[0].ATTRIB_VALUE;
          targetItem[0].ATTRIB_VALUE = evalResult.toFixed();
          if (dataType != null && originalValue !== targetItem[0].ATTRIB_VALUE) {
            targetItem[0].IS_CHANGED_FLAG = 'Y';
          }
        }
      }
    } catch (e) {
      console.error('Error in calcAmt:', e);
    }
  }

  private calcTaxCapitalAmt(formula: string, lineNo: string, attribKey: string, dataType: string, targetFormList: any[]) {
    try {
      const matches = formula.match(/\b[^\d\s]+\b/g);
      let lineFormulaArray: string[] = [];
      if (matches == null) {
        lineFormulaArray = formula.split(/[+-/\\*\\]/);
      }

      for (let i = 0; i < lineFormulaArray.length; i++) {
        lineFormulaArray[i] = lineFormulaArray[i].replace(/"/g, '').replace(/'/g, '').replace(/\(|\)/g, '');
        let formulaOperandText = lineFormulaArray[i].trim();
        let hasGT = false;
        let hasLT = false;

        if (formulaOperandText.includes('>')) { hasGT = true; formulaOperandText = formulaOperandText.replace('>', ''); }
        else if (formulaOperandText.includes('<')) { hasLT = true; formulaOperandText = formulaOperandText.replace('<', ''); }

        const sourceItem = _.find(this.allFormData, { ATTRIB_NAME: formulaOperandText, DATA_TYPE: 'number' });
        if (!sourceItem) continue;
        const lineAmt = parseFloat(sourceItem.ATTRIB_VALUE) || 0;

        if (!hasGT && !hasLT) {
          formula = lineAmt >= 0
            ? formula.replace('(' + formulaOperandText + ')', String(lineAmt))
            : formula.replace('(' + formulaOperandText + ')', '(' + lineAmt + ')');
        } else if (hasGT) {
          formula = lineAmt > 0
            ? formula.replace('(' + formulaOperandText + '(>))', String(lineAmt))
            : formula.replace('(' + formulaOperandText + '(>))', '0');
        } else if (hasLT) {
          formula = lineAmt < 0
            ? formula.replace('(' + formulaOperandText + '(<))', '(' + lineAmt + ')')
            : formula.replace('(' + formulaOperandText + '(<))', '0');
        }
      }

      const evalResult = safeEvalFormula(formula, null, 'partner-alloc-new');
      if (evalResult != null && typeof evalResult !== 'undefined' && isFiniteEvalNumber(evalResult)) {
        const targetItem = _.filter(targetFormList, { LINE_NO: lineNo, LINE_ATTRIB_KEY: attribKey });
        if (targetItem.length > 0) {
          const originalValue = targetItem[0].ATTRIB_VALUE;
          targetItem[0].ATTRIB_VALUE = evalResult.toFixed();
          if (dataType != null && originalValue !== targetItem[0].ATTRIB_VALUE) {
            targetItem[0].IS_CHANGED_FLAG = 'Y';
          }
        }
      }
    } catch (e) {
      console.error('Error in calcTaxCapitalAmt:', e);
    }
  }

  // ─── SK3 TAB LOGIC ───────────────────────────────────────────────────

  setChangeSK3(row: any, item?: any) {
    if (row.ROW_TYPE === 'PL') {
      row.IS_CHANGED_FLAG = 'Y';
      row.ROW_OCCURRENCE = 1;
      row.COL_OCCURRENCE = 1;
    } else if (row.ROW_TYPE === 'DT') {
      row.IS_CHANGED_FLAG = 'Y';
      row.ROW_OCCURRENCE = 1;
      row.COL_OCCURRENCE = 1;
    } else if (row.ROW_TYPE === 'CH' && item) {
      for (let j = 0; j < item.Line_data_occ.length; j++) {
        item.Line_data_occ[j].ROW_OCCURRENCE = item.Row_Occurrence;
        item.Line_data_occ[j].COL_OCCURRENCE = 1;
        item.Line_data_occ[j].IS_CHANGED_FLAG = 'Y';
      }
    }
  }

  calcAlpha(rowOccurrence: number): string {
    return String.fromCharCode(rowOccurrence + 64);
  }

  isShowableLineNo(lineNo: string): boolean {
    return lineNo != null && lineNo !== 'NA' && !lineNo.includes('_');
  }

  togglePartVisibility(partNo: string) {
    const map: any = {
      'I': 'showPartI', 'II': 'showPartII', 'III': 'showPartIII', 'IV': 'showPartIV',
      'V': 'showPartV', 'VI': 'showPartVI', 'VII': 'showPartVII', 'VIII': 'showPartVIII',
      'IX': 'showPartIX', 'X': 'showPartX', 'XI': 'showPartXI', 'XII': 'showPartXII', 'XIII': 'showPartXIII'
    };
    if (map[partNo]) { (this as any)[map[partNo]] = !(this as any)[map[partNo]]; }
    this.cdr.detectChanges();
  }

  isPartVisible(partNo: string): boolean {
    const map: any = {
      'I': 'showPartI', 'II': 'showPartII', 'III': 'showPartIII', 'IV': 'showPartIV',
      'V': 'showPartV', 'VI': 'showPartVI', 'VII': 'showPartVII', 'VIII': 'showPartVIII',
      'IX': 'showPartIX', 'X': 'showPartX', 'XI': 'showPartXI', 'XII': 'showPartXII', 'XIII': 'showPartXIII'
    };
    return map[partNo] ? (this as any)[map[partNo]] : false;
  }

  getSK3PartData(partNo: string): any[] {
    return _.filter(this.all_1065SK3Data, { PART_NO: partNo });
  }

  getPartIHeaders(): any[] {
    return _.filter(this.part_I_1065SK3Data, (r: any) =>
      r.DISPLAY === 'Y' && r.IS_FORM_DISPLAY === 'Y' && r.ROW_TYPE === 'LH'
    );
  }

  getPartICheckboxColumn(lineNos: number[]): any[] {
    return _.filter(this.part_I_1065SK3Data, (r: any) =>
      r.DISPLAY === 'Y' && r.IS_FORM_DISPLAY === 'Y' && r.ROW_TYPE === 'PL' &&
      lineNos.includes(Number(r.LINE_NO))
    );
  }

  // ─── GENERIC PARTS RENDERING (III-XIII except II) ───────────────────

  private computeDescWidths(transposedData: any[]): { descWidth: string, headerDescWidth: string, colWidth: string } {
    // Scan ALL rows (HEADER_ROW and DATA_ROW) across every CH group to find the widest column set.
    // A section can have multiple line groups; only the first gets a HEADER_ROW but subsequent groups
    // may have more visible columns — using only the first HEADER_ROW would undercount and still overflow.
    let maxVisibleCols = 0;
    for (const row of transposedData) {
      if (row.ROW_TYPE === 'CH') {
        for (const item of row.Line_data) {
          if (item.Line_Type === 'HEADER_ROW' || item.Line_Type === 'DATA_ROW') {
            const visibleCols = (item.Line_data_occ || []).slice(1).filter(
              (c: any) => c.DISPLAY === 'Y' && c.IS_FORM_DISPLAY === 'Y'
            ).length;
            if (visibleCols > maxVisibleCols) maxVisibleCols = visibleCols;
          }
        }
      }
    }

    if (maxVisibleCols === 0) {
      return { descWidth: '50%', headerDescWidth: '54%', colWidth: '13%' };
    }

    // Reserve 4% for the line-number cell in data rows; fit desc + cols within remaining 96%.
    // When many columns exist, scale colWidth down so the total never exceeds 100%.
    const minDescWidth = 15;
    let colWidth = 13;
    let dw = 96 - maxVisibleCols * colWidth;
    if (dw < minDescWidth) {
      colWidth = Math.floor((96 - minDescWidth) / maxVisibleCols);
      dw = 96 - maxVisibleCols * colWidth;
    }
    return { descWidth: dw + '%', headerDescWidth: (dw + 4) + '%', colWidth: colWidth + '%' };
  }

  private renderGenericParts() {
    const genericParts = ['III', 'IV', 'V', 'VI', 'VII', 'IX', 'X', 'XI', 'XII', 'XIII'];
    for (const partNo of genericParts) {
      const partData = _.filter(this.all_1065SK3Data, (r: any) =>
        r.PART_NO === partNo && r.ROW_TYPE !== 'PH' && r.ROW_TYPE !== 'AH'
      );
      if (partData.length === 0) {
        this.genericPartSections.set(partNo, []);
        continue;
      }

      const sectionGroups: { [key: string]: any[] } = {};
      const sectionOrder: string[] = [];
      for (const row of partData) {
        const sn = row.SECTION_NAME || 'N/A';
        if (!sectionGroups[sn]) {
          sectionGroups[sn] = [];
          sectionOrder.push(sn);
        }
        sectionGroups[sn].push(row);
      }

      const sections: { sectionHeaders: any[], flatRows: any[], transposedData: any[], descWidth: string, headerDescWidth: string, colWidth: string }[] = [];

      for (const sn of sectionOrder) {
        const sectionData = sectionGroups[sn];
        const sectionHeaders = _.filter(sectionData, (r: any) =>
          r.ROW_TYPE === 'SH' && r.DISPLAY === 'Y' && r.IS_FORM_DISPLAY === 'Y'
        );
        const chRows = _.filter(sectionData, { ROW_TYPE: 'CH' });
        const flatRows = _.filter(sectionData, (r: any) =>
          r.ROW_TYPE !== 'SH' && r.ROW_TYPE !== 'CH' &&
          r.DISPLAY === 'Y' && r.IS_FORM_DISPLAY === 'Y'
        );

        let transposedData: any[] = [];
        if (chRows.length > 0) {
          transposedData = this.transposePartIISection(chRows);
        }

        const { descWidth, headerDescWidth, colWidth } = transposedData.length > 0
          ? this.computeDescWidths(transposedData)
          : { descWidth: '50%', headerDescWidth: '54%', colWidth: '13%' };

        if (sectionHeaders.length > 0 || flatRows.length > 0 || transposedData.length > 0) {
          sections.push({ sectionHeaders, flatRows, transposedData, descWidth, headerDescWidth, colWidth });
        }
      }

      this.genericPartSections.set(partNo, sections);
    }
  }

  getGenericPartSections(partNo: string): { sectionHeaders: any[], flatRows: any[], transposedData: any[], descWidth: string, headerDescWidth: string, colWidth: string }[] {
    return this.genericPartSections.get(partNo) || [];
  }

  addRowOccurrenceGeneric(lineNo: string, transposedSectionData: any[]) {
    let rowOccurrence = 1;
    for (const tRow of transposedSectionData) {
      if (tRow.ROW_TYPE === 'CH') {
        rowOccurrence = tRow.Line_data[tRow.Line_data.length - 1].Row_Occurrence + 1;
      }
      const newRow = _.cloneDeep(tRow.Line_data[tRow.Line_data.length - 1]);
      newRow.Line_Type = 'DATA_ROW';
      newRow.Row_Occurrence = rowOccurrence;
      newRow.IS_EDITTED = 'Y';
      if (newRow.Line_no == lineNo) {
        for (const cell of newRow.Line_data_occ) {
          if ((cell.EDIT_TYPE === 'currency' || cell.EDIT_TYPE === 'label') && cell.DATA_TYPE === 'number') {
            cell.ATTRIBUTE_VALUE = 0;
          } else if (cell.EDIT_TYPE === 'text' && cell.DATA_TYPE === 'string') {
            cell.ATTRIBUTE_VALUE = null;
          }
          cell.ROW_OCCURRENCE = rowOccurrence;
          cell.COL_OCCURRENCE = 1;
        }
        tRow.Line_data.push(newRow);
      }
    }
    this.cdr.detectChanges();
  }

  removeRowOccurrenceGeneric(lineNo: string, occurrence: number, index: number, transposedSectionData: any[]) {
    for (const tRow of transposedSectionData) {
      if (tRow.ROW_TYPE === 'CH') {
        for (let j = 0; j < tRow.Line_data.length; j++) {
          if (j === index) {
            const item = tRow.Line_data[j];
            if ((item.Line_Type === 'DATA_ROW' || item.Line_Type === 'NEW_EDIT_ROW') &&
              item.Line_no == lineNo && item.Row_Occurrence == occurrence) {
              if (item.IS_EDITTED === 'N') {
                tRow.DELETE_ROWS.push(item);
              }
              tRow.Line_data.splice(j, 1);
            }
          }
        }
      }
    }
    this.cdr.detectChanges();
  }

  // ─── PART II TRANSPOSED RENDERING ─────────────────────────────────────

  private renderPartII() {
    this.part_II_s1_header_1065SK3Data = _.filter(this.all_1065SK3Data, (r: any) =>
      r.PART_NO === 'II' && String(r.SECTION_NAME) === '1' && r.ROW_TYPE === 'SH' &&
      r.ATTRIB_NAME && String(r.ATTRIB_NAME).indexOf('1065_K3_II_1') !== -1
    );
    const s1Data = _.filter(this.all_1065SK3Data, (r: any) =>
      r.PART_NO === 'II' && String(r.SECTION_NAME) == '1' && r.ROW_TYPE === 'CH' &&
      r.ATTRIB_NAME && String(r.ATTRIB_NAME).indexOf('1065_K3_II_1') !== -1
    );
    this.part_II_S1_1065SK3DataTransposed = this.transposePartIISection(s1Data);

    this.part_II_s2_header_1065SK3Data = _.filter(this.all_1065SK3Data, (r: any) =>
      r.PART_NO === 'II' && String(r.SECTION_NAME) === '2' && r.ROW_TYPE === 'SH' &&
      r.ATTRIB_NAME && String(r.ATTRIB_NAME).indexOf('1065_K3_II_2') !== -1
    );
    const s2Data = _.filter(this.all_1065SK3Data, (r: any) =>
      r.PART_NO === 'II' && String(r.SECTION_NAME) == '2' && r.ROW_TYPE === 'CH' &&
      r.ATTRIB_NAME && String(r.ATTRIB_NAME).indexOf('1065_K3_II_2') !== -1
    );
    this.part_II_S2_1065SK3DataTransposed = this.transposePartIISection(s2Data);

    for (const line of this.part_II_S2_1065SK3DataTransposed) {
      const dataRows = _.filter(line.Line_data, (d: any) => d.Line_Type === 'DATA_ROW');
      for (const dataRow of dataRows) {
        if (dataRow.Is_Multi === 'Y' && dataRow.Line_no != '32') {
          const countryCol = dataRow.Line_data_occ?.[0];
          if (countryCol && countryCol.ATTRIBUTE_VALUE === undefined) {
            countryCol.ATTRIBUTE_VALUE = this.defaultCountryCode;
          }
        }
      }
    }

    const s1Widths = this.computeDescWidths(this.part_II_S1_1065SK3DataTransposed);
    this.partIIDescWidth = s1Widths.descWidth;
    this.partIIHeaderDescWidth = s1Widths.headerDescWidth;
    this.partIIColWidth = s1Widths.colWidth;

    this.part_II_s1_24h_n_s2_54_1065SK3DataTransposed = [];
    this.part_II_s2_55_1065SK3DataTransposed = null;
    this.reEvaluateFormulaForTotalLinesP2();
  }

  // ─── PART VIII TRANSPOSED RENDERING (TABS) ──────────────────────────

  private renderPartVIII() {
    this.part_VIII_header_1065SK3Data = _.filter(this.all_1065SK3Data, (r: any) =>
      r.PART_NO === 'VIII' && r.SECTION_NAME === 'NA' && r.ROW_TYPE === 'PH' &&
      r.ATTRIB_NAME === '1065_K3_VIII_N/A_N/A'
    );

    const part8Data = _.filter(this.all_1065SK3Data, (r: any) =>
      r.PART_NO === 'VIII' && r.SECTION_NAME === 'NA' &&
      r.ATTRIB_NAME && String(r.ATTRIB_NAME).indexOf('1065_K3_VIII_NA_') !== -1
    );

    for (const row of part8Data) {
      row.IS_CHANGED_FLAG = 'Y';
    }

    const partOccurrences: number[] = [];
    for (const row of part8Data) {
      if (!partOccurrences.includes(row.PART_OCCURRENCE)) {
        partOccurrences.push(row.PART_OCCURRENCE);
      }
    }

    this.part_VIII_1065SK3DataTransposed = this.transposePartsVIII(part8Data, partOccurrences);
  }

  private transposePartsVIII(partsData: any[], partOccurrences: number[]): any[] {
    const result: any[] = [];
    for (const po of partOccurrences) {
      const dtData = _.filter(partsData, (o: any) => o.PART_OCCURRENCE === po && o.ROW_TYPE === 'DT');
      const plData = _.filter(partsData, (o: any) => o.PART_OCCURRENCE === po && o.ROW_TYPE === 'PL');
      const chData = _.filter(partsData, (o: any) => o.PART_OCCURRENCE === po && o.ROW_TYPE === 'CH');
      const transposedCH = chData.length > 0 ? this.transposeCHDataP8(chData) : [];
      result.push(_.cloneDeep({
        PART_OCCURRENCE: po,
        DELETE_OCCURRENCE: 0,
        PART_DATA: [...dtData, ...plData, ...transposedCH],
        IS_NEW_PART_ADDED: 'N'
      }));
    }
    return result;
  }

  private transposeCHDataP8(chData: any[]): any[] {
    const grouped: { [key: string]: any[] } = {};
    for (const row of chData) {
      const key = String(row.LINE_ORDER);
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(row);
    }

    const xposed = Object.keys(grouped).sort((a, b) => Number(a) - Number(b)).map(k => ({
      ROW_TYPE: grouped[k][0].ROW_TYPE,
      DELETE_ROWS: [] as any[],
      Line_data: grouped[k]
    }));

    for (let i = 0; i < xposed.length; i++) {
      const occGrouped: { [key: string]: any[] } = {};
      for (const row of xposed[i].Line_data) {
        const k = String(row.ROW_OCCURRENCE);
        if (!occGrouped[k]) occGrouped[k] = [];
        occGrouped[k].push(row);
      }

      const rows: any[] = Object.keys(occGrouped).map(k => ({
        Line_Type: 'DATA_ROW',
        Is_Multi: occGrouped[k][0].IS_MULTI,
        Line_no: occGrouped[k][0].LINE_NO,
        IS_EDITABLE: occGrouped[k][0].IS_EDITABLE,
        IS_EDITTED: 'N',
        Trans_details_key: occGrouped[k][0].TRANS_DETAILS_KEY,
        Row_Occurrence: occGrouped[k][0].ROW_OCCURRENCE,
        Line_data_occ: occGrouped[k]
      }));

      if (i === 0) {
        const headerRow = _.cloneDeep(rows[0]);
        headerRow.Line_Type = 'HEADER_ROW';
        headerRow.Row_Occurrence = '';
        headerRow.Trans_details_key = '';
        headerRow.IS_EDITABLE = 'Y';

        if (xposed[i].Line_data[0].IS_MULTI === 'Y') {
          rows.unshift(headerRow, { Line_Type: 'SUB_ROW', Line_no: headerRow.Line_no, Line_data_occ: [] });
        } else {
          rows.unshift(headerRow);
        }
      } else {
        const firstKey = Object.keys(occGrouped)[0];
        if (xposed[i].Line_data[0].IS_MULTI === 'Y') {
          rows.unshift({ Line_Type: 'SUB_ROW', Line_no: occGrouped[firstKey][0].LINE_NO, Line_data_occ: [] });
        }
      }

      xposed[i].Line_data = _.cloneDeep(rows);
    }
    return xposed;
  }

  addPartOccurrenceP8() {
    if (this.part_VIII_1065SK3DataTransposed.length === 0) return;
    const maxOcc = Math.max(...this.part_VIII_1065SK3DataTransposed.map((p: any) => p.PART_OCCURRENCE), 0);
    const newPart = _.cloneDeep(this.part_VIII_1065SK3DataTransposed[0]);
    newPart.PART_OCCURRENCE = maxOcc + 1;
    newPart.DELETE_OCCURRENCE = 0;
    newPart.IS_NEW_PART_ADDED = 'Y';

    for (const row of newPart.PART_DATA) {
      if (row.ROW_TYPE === 'DT' || row.ROW_TYPE === 'PL') {
        row.ATTRIBUTE_VALUE = '';
        row.PART_OCCURRENCE = newPart.PART_OCCURRENCE;
      } else if (row.ROW_TYPE === 'CH') {
        row.Line_data = row.Line_data.filter((item: any) =>
          item.Line_Type !== 'DATA_ROW' || item.Row_Occurrence === 1
        );
        for (const item of row.Line_data) {
          if (item.Line_Type === 'DATA_ROW') {
            item.Row_Occurrence = 1;
            for (const cell of item.Line_data_occ) {
              cell.ATTRIBUTE_VALUE = '';
              cell.PART_OCCURRENCE = newPart.PART_OCCURRENCE;
            }
          }
        }
      }
    }

    this.part_VIII_1065SK3DataTransposed.push(newPart);
    this.activePartVIIITab = this.part_VIII_1065SK3DataTransposed.length - 1;
    this.cdr.detectChanges();
  }

  removePartOccurrenceP8(part: any, event: Event) {
    event.stopPropagation();
    if (part.IS_NEW_PART_ADDED === 'N') {
      this.part_VIII_1065SK3DataTransposed_deletePart.push(part);
    }
    const idx = this.part_VIII_1065SK3DataTransposed.indexOf(part);
    if (idx !== -1) {
      this.part_VIII_1065SK3DataTransposed.splice(idx, 1);
    }
    if (this.activePartVIIITab >= this.part_VIII_1065SK3DataTransposed.length) {
      this.activePartVIIITab = Math.max(0, this.part_VIII_1065SK3DataTransposed.length - 1);
    }
    this.cdr.detectChanges();
  }

  addRowOccurrenceP8(lineNo: string, part: any) {
    const chRows = part.PART_DATA.filter((r: any) => r.ROW_TYPE === 'CH');
    for (const chRow of chRows) {
      const dataRows = chRow.Line_data.filter((item: any) => item.Line_Type === 'DATA_ROW' && item.Line_no === lineNo);
      if (dataRows.length > 0) {
        const lastRow = dataRows[dataRows.length - 1];
        const newRow = _.cloneDeep(lastRow);
        newRow.Row_Occurrence = lastRow.Row_Occurrence + 1;
        for (const cell of newRow.Line_data_occ) {
          cell.ATTRIBUTE_VALUE = '';
          cell.ROW_OCCURRENCE = newRow.Row_Occurrence;
          cell.IS_CHANGED_FLAG = 'Y';
        }
        const idx = chRow.Line_data.indexOf(lastRow);
        chRow.Line_data.splice(idx + 1, 0, newRow);
      }
    }
    this.cdr.detectChanges();
  }

  removeRowOccurrenceP8(lineNo: string, occurrence: number, itemIdx: number, part: any) {
    const chRows = part.PART_DATA.filter((r: any) => r.ROW_TYPE === 'CH');
    for (const chRow of chRows) {
      const targetIdx = chRow.Line_data.findIndex((item: any) =>
        item.Line_Type === 'DATA_ROW' && item.Line_no === lineNo && item.Row_Occurrence === occurrence
      );
      if (targetIdx !== -1) {
        const removed = chRow.Line_data.splice(targetIdx, 1);
        if (!chRow.DELETE_ROWS) chRow.DELETE_ROWS = [];
        chRow.DELETE_ROWS.push(...removed);
      }
    }
    this.cdr.detectChanges();
  }

  setChangeSK3P8(fmrec: any, item?: any) {
    fmrec.IS_CHANGED_FLAG = 'Y';
  }

  private transposePartIISection(sectionData: any[]): any[] {
    if (!sectionData || sectionData.length === 0) return [];

    const grouped: { [key: string]: any[] } = {};
    for (const item of sectionData) {
      const key = String(item.LINE_ORDER);
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(item);
    }

    const transposed = Object.keys(grouped).sort((a, b) => Number(a) - Number(b)).map(k => ({
      ROW_TYPE: grouped[k][0].ROW_TYPE,
      DELETE_ROWS: [] as any[],
      Line_data: grouped[k]
    }));

    for (let i = 0; i < transposed.length; i++) {
      const occGrouped: { [key: string]: any[] } = {};
      for (const item of transposed[i].Line_data) {
        const key = String(item.ROW_OCCURRENCE);
        if (!occGrouped[key]) occGrouped[key] = [];
        occGrouped[key].push(item);
      }

      let occRows: any[] = Object.keys(occGrouped).map(k => ({
        Line_Type: 'DATA_ROW',
        Is_Multi: occGrouped[k][0].IS_MULTI,
        Line_no: occGrouped[k][0].LINE_NO,
        IS_EDITABLE: occGrouped[k][0].IS_EDITABLE,
        IS_EDITTED: 'N',
        Trans_details_key: occGrouped[k][0].TRANS_DETAILS_KEY,
        Row_Occurrence: occGrouped[k][0].ROW_OCCURRENCE,
        Line_data_occ: occGrouped[k]
      }));

      if (i === 0) {
        const headerRow = _.cloneDeep(occRows[0]);
        headerRow.Line_Type = 'HEADER_ROW';
        headerRow.Row_Occurrence = '';
        headerRow.Trans_details_key = '';
        headerRow.IS_EDITABLE = 'Y';
        for (const cell of headerRow.Line_data_occ) {
          cell.ATTRIB_VALUE = cell.ATTRIB_DESCRIPTION;
        }
        if (transposed[i].Line_data[0].IS_MULTI === 'Y') {
          occRows.unshift(headerRow, { Line_Type: 'SUB_ROW', Line_no: headerRow.Line_no, Line_data_occ: [] });
        } else {
          occRows.unshift(headerRow);
        }
      } else {
        const firstKey = Object.keys(occGrouped)[0];
        if (transposed[i].Line_data[0].IS_MULTI === 'Y') {
          occRows.unshift({ Line_Type: 'SUB_ROW', Line_no: occGrouped[firstKey][0].LINE_NO, Line_data_occ: [] });
        }
      }

      transposed[i].Line_data = _.cloneDeep(occRows);
    }

    return transposed;
  }

  getLastLineDescription(row: any): string {
    if (!row?.Line_data?.length) return '';
    const lastItem = row.Line_data[row.Line_data.length - 1];
    return lastItem?.Line_data_occ?.[0]?.LINE_DESCRIPTION || '';
  }

  addRowOccurrenceP2(lineNo: string, transposedSectionData: any[]) {
    let rowOccurrence = 1;
    for (const tRow of transposedSectionData) {
      if (tRow.ROW_TYPE === 'CH') {
        rowOccurrence = tRow.Line_data[tRow.Line_data.length - 1].Row_Occurrence + 1;
      }
      const newRow = _.cloneDeep(tRow.Line_data[tRow.Line_data.length - 1]);
      newRow.Line_Type = 'DATA_ROW';
      newRow.Row_Occurrence = rowOccurrence;
      newRow.IS_EDITTED = 'Y';
      if (newRow.Line_no == lineNo) {
        for (const cell of newRow.Line_data_occ) {
          if ((cell.EDIT_TYPE === 'currency' || cell.EDIT_TYPE === 'label') && cell.DATA_TYPE === 'number') {
            cell.ATTRIBUTE_VALUE = 0;
          } else if (cell.EDIT_TYPE === 'text' && cell.DATA_TYPE === 'string') {
            cell.ATTRIBUTE_VALUE = null;
            if (cell.SECTION_NAME === '2' && cell.ATTRIB_COL === '0' && cell.LINE_NO !== '32') {
              cell.ATTRIBUTE_VALUE = this.defaultCountryCode;
            }
          }
          cell.ROW_OCCURRENCE = rowOccurrence;
          cell.COL_OCCURRENCE = 1;
        }
        tRow.Line_data.push(newRow);
      }
    }
    this.cdr.detectChanges();
  }

  removeRowOccurrenceP2(lineNo: string, occurrence: number, index: number, transposedSectionData: any[]) {
    for (const tRow of transposedSectionData) {
      if (tRow.ROW_TYPE === 'CH') {
        for (let j = 0; j < tRow.Line_data.length; j++) {
          if (j === index) {
            const item = tRow.Line_data[j];
            if ((item.Line_Type === 'DATA_ROW' || item.Line_Type === 'NEW_EDIT_ROW') &&
              item.Line_no == lineNo && item.Row_Occurrence == occurrence) {
              if (item.IS_EDITTED === 'N') {
                tRow.DELETE_ROWS.push(item);
              }
              tRow.Line_data.splice(j, 1);
            }
          }
        }
      }
    }
    this.reEvaluateFormulaForTotalLinesP2();
    this.cdr.detectChanges();
  }

  applyFormulaSK3P2(item: any, fmrec: any) {
    this.setChangeSK3(fmrec, item);
    const cellName = fmrec.ATTRIB_NAME;
    const formulaObjs = _.filter(this.allFormFormulaListSK3, (f: any) =>
      f.ATTRIB_CALC_FORMULA && String(f.ATTRIB_CALC_FORMULA).indexOf('(' + cellName + ')') !== -1
    );

    for (let k = 0; k < formulaObjs.length; k++) {
      let formula = formulaObjs[k].ATTRIB_CALC_FORMULA;
      const matches = formula.match(/\b[^\d\s]+\b/g);
      let lineFormulaArray: string[] = [];
      if (matches == null) {
        lineFormulaArray = formula.split(/[+-/\\*\\]/);
      }
      for (let i = 0; i < lineFormulaArray.length; i++) {
        lineFormulaArray[i] = lineFormulaArray[i].replace(/"/g, '').replace(/'/g, '').replace(/\(|\)/g, '');
        const operandText = lineFormulaArray[i].trim();
        let lineAmt = 0;

        if (k === 0) {
          const sourceCell = _.find(item.Line_data_occ, { ATTRIB_NAME: operandText });
          lineAmt = sourceCell ? parseFloat(sourceCell.ATTRIBUTE_VALUE) || 0 : 0;
        } else if (k === 1) {
          let occAmt = 0;
          const sectionData = String(fmrec.SECTION_NAME) == '1'
            ? this.part_II_S1_1065SK3DataTransposed
            : this.part_II_S2_1065SK3DataTransposed;
          for (const line of sectionData) {
            const dataRows = _.filter(line.Line_data, (d: any) => d.Line_Type === 'DATA_ROW');
            for (const dr of dataRows) {
              for (const cell of dr.Line_data_occ) {
                if (cell.ATTRIB_NAME === operandText) {
                  occAmt += parseFloat(cell.ATTRIBUTE_VALUE) || 0;
                }
              }
            }
          }
          lineAmt = occAmt;
        }

        formula = lineAmt >= 0
          ? formula.replace('(' + operandText + ')', String(lineAmt))
          : formula.replace('(' + operandText + ')', '(' + lineAmt + ')');
      }

      try {
        const evalResult = safeEvalFormula(formula, null, 'partner-alloc-new');
        if (evalResult != null && typeof evalResult !== 'undefined' && isFiniteEvalNumber(evalResult)) {
          if (k === 0) {
            const targetCell = _.find(item.Line_data_occ, { ATTRIB_NAME: formulaObjs[k].ATTRIB_NAME });
            if (targetCell) {
              const originalValue = targetCell.ATTRIBUTE_VALUE;
              if (originalValue != evalResult) this.setChangeSK3(targetCell, item);
              targetCell.ATTRIBUTE_VALUE = evalResult.toFixed();
            }
          } else if (k === 1) {
            const sectionData = String(fmrec.SECTION_NAME) == '1'
              ? this.part_II_S1_1065SK3DataTransposed
              : this.part_II_S2_1065SK3DataTransposed;
            for (const line of sectionData) {
              const dataRows = _.filter(line.Line_data, (d: any) => d.Line_Type === 'DATA_ROW');
              for (const dr of dataRows) {
                if (dr.Line_no == formulaObjs[k].LINE_NO) {
                  const targetCell = _.find(dr.Line_data_occ, { ATTRIB_NAME: formulaObjs[k].ATTRIB_NAME });
                  if (targetCell) {
                    const originalValue = targetCell.ATTRIBUTE_VALUE;
                    if (dr.Line_no !== '24h' && originalValue != evalResult) this.setChangeSK3(targetCell, dr);
                    targetCell.ATTRIBUTE_VALUE = evalResult.toFixed();
                  }
                }
              }
            }
          }
        }
      } catch (e) {
        console.error('Error in applyFormulaSK3P2:', e);
      }
    }
    this.reEvaluateFormulaForTotalLinesP2();
    this.cdr.detectChanges();
  }

  private reEvaluateFormulaForTotalLinesP2() {
    this.evaluateFormulaForLine('24h', this.part_II_S1_1065SK3DataTransposed, false);
    this.evaluateFormulaForLine('54', this.part_II_S2_1065SK3DataTransposed, true);

    this.part_II_s1_24h_n_s2_54_1065SK3DataTransposed = [];
    for (const line of this.part_II_S1_1065SK3DataTransposed) {
      const ld = _.filter(line.Line_data, (d: any) => d.Line_Type === 'DATA_ROW' && d.Is_Multi === 'N' && d.Line_no === '24h');
      if (ld.length > 0) { this.part_II_s1_24h_n_s2_54_1065SK3DataTransposed.push(line); break; }
    }
    for (const line of this.part_II_S2_1065SK3DataTransposed) {
      const ld = _.filter(line.Line_data, (d: any) => d.Line_Type === 'DATA_ROW' && d.Is_Multi === 'N' && d.Line_no === '54');
      if (ld.length > 0) { this.part_II_s1_24h_n_s2_54_1065SK3DataTransposed.push(line); break; }
    }
    for (const line of this.part_II_S2_1065SK3DataTransposed) {
      const ld = _.filter(line.Line_data, (d: any) => d.Line_Type === 'DATA_ROW' && d.Is_Multi === 'N' && d.Line_no === '55');
      if (ld.length > 0) { this.part_II_s2_55_1065SK3DataTransposed = line; break; }
    }
    if (this.part_II_s2_55_1065SK3DataTransposed) {
      this.evaluateFormulaForLine('55', this.part_II_s1_24h_n_s2_54_1065SK3DataTransposed, true, this.part_II_s2_55_1065SK3DataTransposed);
    }
  }

  private evaluateFormulaForLine(lineNo: string, searchData: any[], markChanges: boolean, targetLine?: any) {
    if (!searchData || searchData.length === 0) return;
    const formulaObjs = _.filter(this.allFormFormulaListSK3, { LINE_NO: lineNo });
    for (const formulaObj of formulaObjs) {
      let formula = formulaObj.ATTRIB_CALC_FORMULA;
      const matches = formula.match(/\b[^\d\s]+\b/g);
      let lineFormulaArray: string[] = [];
      if (matches == null) {
        lineFormulaArray = formula.split(/[+-/\\*\\]/);
      }
      for (let i = 0; i < lineFormulaArray.length; i++) {
        lineFormulaArray[i] = lineFormulaArray[i].replace(/"/g, '').replace(/'/g, '').replace(/\(|\)/g, '');
        const operandText = lineFormulaArray[i].trim();
        let occAmt = 0;
        for (const line of searchData) {
          const dataRows = _.filter(line.Line_data, (d: any) => d.Line_Type === 'DATA_ROW');
          for (const dr of dataRows) {
            for (const cell of dr.Line_data_occ) {
              if (cell.ATTRIB_NAME === operandText) {
                occAmt += parseFloat(cell.ATTRIBUTE_VALUE) || 0;
              }
            }
          }
        }
        formula = occAmt >= 0
          ? formula.replace('(' + operandText + ')', String(occAmt))
          : formula.replace('(' + operandText + ')', '(' + occAmt + ')');
      }
      try {
        const evalResult = safeEvalFormula(formula, null, 'partner-alloc-new');
        if (evalResult != null && typeof evalResult !== 'undefined' && isFiniteEvalNumber(evalResult)) {
          const scanData = targetLine ? [targetLine] : searchData;
          for (const line of scanData) {
            const dataRows = _.filter(line.Line_data, (d: any) => d.Line_Type === 'DATA_ROW');
            for (const dr of dataRows) {
              if (dr.Line_no == formulaObj.LINE_NO) {
                const targetCell = _.find(dr.Line_data_occ, { ATTRIB_NAME: formulaObj.ATTRIB_NAME });
                if (targetCell) {
                  const originalValue = targetCell.ATTRIBUTE_VALUE;
                  if (markChanges && originalValue != evalResult) this.setChangeSK3(targetCell, dr);
                  targetCell.ATTRIBUTE_VALUE = evalResult.toFixed();
                }
              }
            }
          }
        }
      } catch (e) { /* formula evaluation error */ }
    }
  }

  private obtainChangesGenericParts(): any[] {
    const changes: any[] = [];
    const genericParts = ['III', 'IV', 'V', 'VI', 'VII', 'IX', 'X', 'XI', 'XII', 'XIII'];
    for (const partNo of genericParts) {
      const sections = this.genericPartSections.get(partNo) || [];
      for (const section of sections) {
        for (const cell of section.flatRows) {
          if (cell.IS_CHANGED_FLAG === 'Y') {
            changes.push(cell);
          }
        }
        if (section.transposedData.length > 0) {
          for (const line of section.transposedData) {
            const dataRows = _.filter(line.Line_data, (d: any) => d.Line_Type === 'DATA_ROW');
            for (const dr of dataRows) {
              const changedCells = _.filter(dr.Line_data_occ, { IS_CHANGED_FLAG: 'Y' });
              changes.push(...changedCells);
            }
            if (line.DELETE_ROWS && line.DELETE_ROWS.length > 0) {
              for (const delRow of line.DELETE_ROWS) {
                for (const cell of delRow.Line_data_occ) {
                  cell.IS_CHANGED_FLAG = 'D';
                  changes.push(cell);
                }
              }
            }
          }
        }
      }
    }
    return changes;
  }

  private obtainChangesPartII(): any[] {
    const changes: any[] = [];
    const sections = [this.part_II_S1_1065SK3DataTransposed, this.part_II_S2_1065SK3DataTransposed];

    for (const sectionData of sections) {
      if (!sectionData || sectionData.length === 0) continue;
      for (const line of sectionData) {
        const dataRows = _.filter(line.Line_data, (d: any) => d.Line_Type === 'DATA_ROW');
        for (const dr of dataRows) {
          const changedCells = _.filter(dr.Line_data_occ, { IS_CHANGED_FLAG: 'Y' });
          for (const cell of changedCells) {
            changes.push(cell);
          }
        }
        if (line.DELETE_ROWS && line.DELETE_ROWS.length > 0) {
          for (const delRow of line.DELETE_ROWS) {
            for (const cell of delRow.Line_data_occ) {
              cell.IS_CHANGED_FLAG = 'D';
              changes.push(cell);
            }
          }
        }
      }
    }
    return changes;
  }

  private obtainChangesPartVIII(): any[] {
    const changes: any[] = [];

    for (const part of this.part_VIII_1065SK3DataTransposed) {
      for (const row of part.PART_DATA) {
        if (row.ROW_TYPE === 'DT' || row.ROW_TYPE === 'PL') {
          if (row.IS_CHANGED_FLAG === 'Y') {
            changes.push(row);
          }
        } else if (row.ROW_TYPE === 'CH') {
          const dataRows = _.filter(row.Line_data, (d: any) => d.Line_Type === 'DATA_ROW');
          for (const dr of dataRows) {
            const changedCells = _.filter(dr.Line_data_occ, { IS_CHANGED_FLAG: 'Y' });
            changes.push(...changedCells);
          }
          if (row.DELETE_ROWS && row.DELETE_ROWS.length > 0) {
            for (const delRow of row.DELETE_ROWS) {
              for (const cell of delRow.Line_data_occ) {
                cell.IS_CHANGED_FLAG = 'D';
                changes.push(cell);
              }
            }
          }
        }
      }
    }

    for (const part of this.part_VIII_1065SK3DataTransposed_deletePart) {
      for (const row of part.PART_DATA) {
        if (row.ROW_TYPE === 'DT' || row.ROW_TYPE === 'PL') {
          row.IS_CHANGED_FLAG = 'D';
          changes.push(row);
        } else if (row.ROW_TYPE === 'CH') {
          const dataRows = _.filter(row.Line_data, (d: any) => d.Line_Type === 'DATA_ROW');
          for (const dr of dataRows) {
            for (const cell of dr.Line_data_occ) {
              cell.IS_CHANGED_FLAG = 'D';
              changes.push(cell);
            }
          }
        }
      }
    }
    return changes;
  }

  // ─── SAVE ─────────────────────────────────────────────────────────────

  saveAndPost() {
    if (this.crudLoading) {
      this.gtwSnackbar.openSnackBar('Please wait while we save this request', 'gtw-snackbar--yellow', true, 4);
      return;
    }

    if (this.issueList.length > 0 && this.issueList[0].SCENARIO_TYPE_CODE === 'EXAM') {
      if (this.selectedIssue === '') {
        this.gtwSnackbar.openSnackBar('Please select an issue from the list', 'gtw-snackbar--red', true, 4);
        return;
      }
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.cdr.detectChanges();

    const issueID = (this.issueList.length > 0 && this.issueList[0].SCENARIO_TYPE_CODE === 'EXAM' && this.selectedIssue !== '')
      ? this.selectedIssue.split('--')[0]
      : '0';

    const allSaveData: any[][] = [];

    // TI tab data - use function-based filter (AngularJS $filter does substring matching)
    const tiSaveData = _.filter(this.allFormData, (r: any) =>
      r.IS_CHANGED_FLAG === 'Y' &&
      r.ATTRIB_COL != null && String(r.ATTRIB_COL).toLowerCase().indexOf('a') !== -1
    );
    allSaveData.push(tiSaveData);

    // SK3 tab data - collect changes from all sources
    const sk3SaveData: any[] = [];

    // Page 1 changes
    const page1HeaderChanges = _.filter(this.page1Header_1065SK3Data, { IS_CHANGED_FLAG: 'Y' });
    const page1ELineChanges = _.filter(this.page1_E_lines_1065SK3Data, { IS_CHANGED_FLAG: 'Y' });
    sk3SaveData.push(...page1HeaderChanges, ...page1ELineChanges);

    // Part I changes + always include attachment record
    const partIChanges = _.filter(this.part_I_1065SK3Data, { IS_CHANGED_FLAG: 'Y' });
    sk3SaveData.push(...partIChanges);
    const partIAttachment = _.filter(this.all_1065SK3Data, (r: any) =>
      r.PART_NO === 'I' && r.SECTION_NAME === 'NA' && r.ROW_TYPE === 'AH' &&
      r.ATTRIB_NAME && String(r.ATTRIB_NAME).indexOf('1065_K3_I_NA_NA') !== -1
    );
    if (partIAttachment.length > 0) {
      sk3SaveData.push(partIAttachment[0]);
    }

    // Part II changes from transposed data
    sk3SaveData.push(...this.obtainChangesPartII());

    // Part VIII changes (tab-based)
    sk3SaveData.push(...this.obtainChangesPartVIII());

    // Other parts (III-XIII) changes from generic part sections
    sk3SaveData.push(...this.obtainChangesGenericParts());

    allSaveData.push(sk3SaveData);

    console.log('[SAVE DEBUG] allFormData total:', this.allFormData.length,
      'changed:', _.filter(this.allFormData, { IS_CHANGED_FLAG: 'Y' }).length);
    console.log('[SAVE DEBUG] TI save data:', tiSaveData.length, tiSaveData);
    console.log('[SAVE DEBUG] all_1065SK3Data total:', this.all_1065SK3Data.length);
    console.log('[SAVE DEBUG] partIAttachment found:', partIAttachment.length, partIAttachment);
    console.log('[SAVE DEBUG] SK3 save data total:', sk3SaveData.length, sk3SaveData);

    const EXTK3FormSaveDtls: any[] = [];

    // Process TI data
    for (let i = 0; i < allSaveData[0].length; i++) {
      const row = allSaveData[0][i];
      const returnObj: any = {
        section_name: 'main',
        pship_ptr_posting_key: this.PSHIP_PTR_POSTING_KEY,
        combination_key: this.COMBINATION_KEY,
        ptr_combination_key: this.PTR_COMBINATION_KEY,
        chart_key: row.CHART_REF_KEY,
        acct_ref_key: row.ACCT_REFERENCE_KEY,
        allocation_amount: (typeof row.ATTRIB_VALUE === 'object' && row.SUB_FORM != null)
          ? JSON.stringify(row.ATTRIB_VALUE)
          : row.ATTRIB_VALUE,
        flow_through: 0
      };
      EXTK3FormSaveDtls.push(returnObj);
    }

    // Process SK3 data
    for (let i = 0; i < allSaveData[1].length; i++) {
      const returnObj = allSaveData[1][i];
      if (returnObj.LINE_NO !== '24h') {
        EXTK3FormSaveDtls.push(returnObj);
      }
    }

    const scenarioVal = this.scenario || this.filterParams.scenario || '';

    const returnClobSettingsObj: any = {
      tax_year: String(this.TAX_YEAR),
      scenario: scenarioVal !== '' ? Number(scenarioVal) : scenarioVal,
      jcd_key: String(this.jcd_key),
      sso_id: String(this.logged_in_user),
      issue_id: Number(issueID) || 0,
      pship_ptr_posting_key: this.PSHIP_PTR_POSTING_KEY,
      combination_key: this.COMBINATION_KEY,
      ptr_combination_key: this.PTR_COMBINATION_KEY
    };

    console.log('[SAVE DEBUG] EXTK3FormSaveDtls final:', EXTK3FormSaveDtls.length, EXTK3FormSaveDtls);
    console.log('[SAVE DEBUG] clob_settings:', returnClobSettingsObj);

    this.service.savePartnerAllocationForm(
      this.GENERAL_CONFIG.base_url, returnClobSettingsObj, EXTK3FormSaveDtls
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;
        if (response.errorMessage && response.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(response.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar('Partner Allocation Details successfully saved and posted', 'gtw-snackbar--green', true, 4);
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;
        this.gtwSnackbar.openSnackBar('Error occurred while saving.', 'gtw-snackbar--red', true, 4);
        this.cdr.detectChanges();
      }
    );
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }

  // ─── UTILITY ──────────────────────────────────────────────────────────

  isJson(str: any): boolean {
    try { safeJsonInput<any>(str, null, 'partner-alloc-new.parse2'); } catch (e) { return false; }
    return true;
  }

  formatNumber(value: any): string {
    if (value == null || value === '') return '';
    const num = Number(value);
    if (isNaN(num)) return value;
    if (num < 0) {
      return '(' + Math.abs(num).toLocaleString('en-US') + ')';
    }
    return num.toLocaleString('en-US');
  }

  trackByIndex(index: number): number {
    return index;
  }

  formatBytes(bytes: any, decimals = 2): string {
    if (!bytes || bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
